import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '@app/env-service';

import { ProductCategory } from '../store/category.model';

@Injectable({
  providedIn: 'root',
})
export class SubCategoryService {
  url :string = environment.url;
  gettingRecords :boolean;

  readonly _subCategories = new BehaviorSubject<ProductCategory[]>([]);
  readonly _subCategoriesDetailed = new BehaviorSubject<ProductCategory[]>([]);

  subCategories$ :any[] = [];
  subCategoriesDetailed$ :any[] = [];

  public allSubCategories$ = this._subCategories.asObservable();

  constructor(private http :HttpClient) {
    this.get();
    this.getWithCategory();
  }

  get() {
    this.gettingRecords = true;
    this.http
      .get(`${this.url}/subcategories`)
      .subscribe((data :ProductCategory[]) => {
        this.gettingRecords = false;
        this.subCategories$ = data;
        this._subCategories.next(data);
      });
  }

  getWithCategory() :void {
    this.gettingRecords = true;
    this.http.get(`${this.url}/subcategories/detailed`).subscribe((data :any[]) => {
      data.forEach((sub) => {
        sub['subcategory_detailed'] =
          sub.category.product_category + ' - ' + sub.sub_category;
      });
      this.gettingRecords = false;
      this.subCategoriesDetailed$ = data;
      this._subCategoriesDetailed.next(data);
    });
  }
}
